import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import CursorEffect from "./components/CursorEffect";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div>
      <BrowserRouter>
        <CursorEffect />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
